/* Evil Goods - affiliate sign-up funnel tracking
   Added 19 Sep 2026 by eg-web-affiliate-programs. Staged on the duplicate theme only.

   WHY: the two sign-up buttons on /pages/over-1-7-million-already-paid-to-affiliates
   load the Snowball form into an IFRAME on the same page. There is no outbound click
   and no form submit we can see, so visits -> lane choice has never been countable.

   WHAT: fires one Klaviyo event per lane per page view, so it joins the affiliate
   funnel metrics already in Klaviyo (Signed up as an affiliate via sign up form /
   Pending / Approved / Affiliate Sample Code Issued) and the funnel can be read
   end to end for the first time.

   SAFE BY DESIGN: delegated capture-phase listener, everything wrapped in try/catch,
   never calls preventDefault, never touches the iframe src. If Klaviyo is absent or
   throws, the sign-up form behaves exactly as it does today.

   TO REMOVE: delete this file and the one <script src> line in sections/eg-signup.liquid. */
(function () {
  if (window.__egAffiliateTracking) { return; }
  window.__egAffiliateTracking = true;

  var LANES = {
    '45214976-7236-494a-bb53-144d700bcf0f': 'under-10k',
    '032b4607-6645-4f54-bb1e-7cf87f6695ee': 'over-10k'
  };
  var seen = {};

  function track(btn) {
    try {
      var formId = btn.getAttribute('data-form') || '';
      var lane = LANES[formId] || 'unknown';
      if (seen[lane]) { return; }
      seen[lane] = true;
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(['track', 'Affiliate Sign Up Form Opened', {
        Lane: lane,
        Label: btn.getAttribute('data-label') || '',
        FormId: formId,
        Page: window.location.pathname
      }]);
    } catch (e) {}
  }

  document.addEventListener('click', function (ev) {
    try {
      var t = ev.target;
      var btn = t && t.closest ? t.closest('#eg-join .eg-choice[data-form]') : null;
      if (btn) { track(btn); }
    } catch (e) {}
  }, true);
})();
